import React, { useRef } from 'react';
//import Dropdown from './Dropdown';
import Search from '../images/search.svg';

function SearchBar({ title, onSearchChange }) {
  const inputRef = useRef();
  return (
    <form className="search-bar">
        <div className="search">
          <img src={Search} alt="Search" onClick={(e) => onSearchChange(inputRef.current.value)} />
          <input type="text" id="search" name="search" placeholder='Search' ref={inputRef} />
        </div>
        {title && <span>{title}</span>}
        {/*<Dropdown title="Private Projects" inverted={false} />
        <span><i className="icon-filter"></i> Filter</span>
        <span><i className="icon-sort"></i> Sort by</span>*/}
    </form>
  );
}

export default SearchBar;